import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import React, { ReactNode, useState } from 'react';
import { Cookie } from '@/api/sanity/cookies';
import { motion, useAnimation } from 'framer-motion';
import { Button } from '@/components/buttons';
import IconChevronDown from '@/assets/icons/heroIcons/Chevron-down.svg';
interface Props {
  icon: ReactNode;
  control: ReactNode;
  title: string;
  text: string;
  cookies?: Cookie[];
  additionalCookies?: {
    description: string;
    list: Cookie[];
  };
}
const CookiesTable = t0 => {
  const $ = _c(24);
  const {
    cookies
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["privacySettings"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("table.name");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <p>{t2}</p>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("table.description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <p>{t4}</p>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("table.info");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <p>{t6}</p>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t5 || $[15] !== t7) {
    t8 = <div className="p-4 text-xs font-semibold md:grid md:grid-cols-3 md:grid-rows-1 md:gap-4 md:p-6 md:text-sm">{t3}{t5}{t7}</div>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== cookies) {
    t9 = cookies.map(_temp);
    $[17] = cookies;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <div className="flex flex-col gap-2">{t9}</div>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t8) {
    t11 = <>{t8}{t10}</>;
    $[21] = t10;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};
export function SettingBox(t0) {
  const $ = _c(29);
  const {
    icon,
    title,
    text,
    cookies,
    control,
    additionalCookies
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["privacySettings"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const [isOpen, setIsOpen] = useState(false);
  const controls = useAnimation();
  let t2;
  if ($[1] !== controls || $[2] !== isOpen) {
    t2 = () => {
      setIsOpen(!isOpen);
      controls.start(isOpen ? "closed" : "open");
    };
    $[1] = controls;
    $[2] = isOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const toggleList = t2;
  let t3;
  if ($[4] !== icon) {
    t3 = <div className="text-blue-500 [&>svg]:h-6 [&>svg]:w-6 lg:[&>svg]:h-10 lg:[&>svg]:w-10">{icon}</div>;
    $[4] = icon;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== title) {
    t4 = <h2 className="text-lg font-bold lg:text-4xl">{title}</h2>;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="flex flex-row items-center justify-start gap-3 lg:gap-4">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== control) {
    t6 = <div>{control}</div>;
    $[11] = control;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className="flex flex-row items-center justify-between gap-4">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== text) {
    t8 = <p className="mt-3 lg:mt-6">{text}</p>;
    $[16] = text;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== additionalCookies || $[19] !== controls || $[20] !== cookies || $[21] !== isOpen || $[22] !== t || $[23] !== toggleList) {
    t9 = cookies && cookies.length > 0 && <><motion.div animate={controls} initial="closed" variants={{
        open: {
          height: "auto"
        },
        closed: {
          height: "0"
        }
      }} className="overflow-hidden"><CookiesTable cookies={cookies} />{additionalCookies && additionalCookies.list.length > 0 && <><div className="mt-10">{additionalCookies.description}</div><CookiesTable cookies={additionalCookies.list} /></>}</motion.div><div className="mt-4 flex flex-col items-end justify-center"><Button testId="investmentNoticeToggle" analyticsParam="investmentNoticeToggle" onClick={toggleList} className="flex flex-row items-center justify-center text-blue-500" variant="unstyled" rightIcon={<motion.span animate={controls} initial="closed" variants={{
          open: {
            rotate: "-180deg"
          },
          closed: {
            rotate: 0
          }
        }} className="relative flex"><IconChevronDown /></motion.span>}><span className="text-lg text-gray-900">{isOpen ? t("actions.close") : t("actions.open")}</span></Button></div></>;
    $[18] = additionalCookies;
    $[19] = controls;
    $[20] = cookies;
    $[21] = isOpen;
    $[22] = t;
    $[23] = toggleList;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t10 = <div className="rounded-lg bg-white p-4 lg:p-6">{t7}{t8}{t9}</div>;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}
function _temp(t0, key) {
  const {
    title,
    description,
    link
  } = t0;
  return <div key={key} className="items-center overflow-hidden rounded-2xl border-[1px] border-blue-100 p-4 text-xs break-words md:grid md:grid-cols-3 md:grid-rows-1 md:gap-4 md:px-6 md:py-3 md:text-sm"><p>{title}</p><p className="my-2 border-t-[1px] border-b-[1px] border-blue-100 py-2 md:m-0 md:border-0 md:p-0">{description}</p><p>{link}</p></div>;
}